import { PlayerStates } from "../../GameConfig/PlayerConfig.js";
import { InputConfig } from "../../GameConfig/GameConfig.js";
import State from "./states.js";
import CannonBullet from "../weapons/CannonBullet.js";
import { PickupAbility } from "../../GameConfig/PickupConfig.js";

export default class Attack extends State {
  constructor(game) {
    super(PlayerStates.ATTACK);
    this.game = game;
  }

  enter() {}

  handleInput(input) {
    if (input.has(InputConfig.ATTACK) && this.game.currentAmmo > 0) {
      this.game.playerWeaponProjectiles.push(new CannonBullet(this.game));

      // if turret is not active then decrease ammo else unlimited ammo
      if (!this.game.player.ability.has(PickupAbility.TURRET))
        this.game.currentAmmo -= 1;
    }
    if (input.has(InputConfig.UP) || input.has(InputConfig.DOWN)) {
      this.game.player.setState(PlayerStates.FLY);
    }
  }
}
